document.addEventListener("DOMContentLoaded", function () {
  changeBgColor();
  removePageWidth();
  capitalizeBodyFirstLetter();
  console.log("adjustImageSize");
  setTimeout(adjustImageSize, 1000);
});

function changeBgColor() {
  const section = document
    .querySelector(".jdgm-carousel-wrapper")
    ?.closest("section");
  if (!section) return;

  section.style.backgroundColor = "#fff";
}

function removePageWidth() {
  const carouselWrapper = document.querySelector(".jdgm-carousel-wrapper");
  if (!carouselWrapper) return;

  const carouselSection = carouselWrapper.closest(".page-width");
  const carouselMaxLimited = carouselWrapper.parentElement;
  carouselMaxLimited.style.maxWidth = "unset";
  carouselSection.classList.remove("page-width");
  carouselSection.classList.add("jdgm--custom");
}

function capitalizeBodyFirstLetter() {
  const reviewBodies = document.querySelectorAll(
    ".jdgm-carousel-item__review-body p"
  );
  if (reviewBodies.length === 0) return;

  reviewBodies.forEach((reviewBody) => {
    const text = reviewBody.textContent;
    const firstLetter = text.charAt(0).toUpperCase();
    const restOfText = text.slice(1);
    reviewBody.textContent = firstLetter + restOfText;
  });
}

function adjustImageSize() {
  console.log("adjustImageSize2");
  const images = document.querySelectorAll(
    ".jdgm-carousel-item__product-image"
  );
  if (images.length === 0) return;

  images.forEach((image) => {
    let newSrc = image
      .getAttribute("data-src")
      .replace(/_\d+x\d+\./, "_400x400.")
      .replace(/w=\d+/, "w=400");

    if (!newSrc) return;
    image.addEventListener("load", function () {
      image.src = newSrc;
    });
  });
}
